// src/pages/Privacy.jsx
import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import PrivacyBanner from "../components/PrivacyBanner"; // Banner for Privacy
import Footer from "../components/Footer";
import PrivacyPolicy from "../components/PrivacyPolicy"; // Content for Privacy

const Privacy = () => {
  return (
    <>
      <CustomNavbar />
      <PrivacyBanner />
      <PrivacyPolicy />
      <Footer />
    </>
  );
};

export default Privacy;
